import { c as _c } from "react/compiler-runtime";
import { useIsMobile } from "@/hooks/use-mobile";
import { useFormContext, useWatch } from "react-hook-form";
import { ListingType } from "../../../api/schema";
import { useTranslations } from "next-intl";
export const ROOM_FLAG_KEYS = ["petFriendly", "contract", "smokingAllowed"] as const;
export function useHouseDetails() {
  const $ = _c(19);
  const {
    control,
    setValue
  } = useFormContext();
  const isMobile = useIsMobile();
  const t = useTranslations("modules.listings.addRoomListing.houseDetails");
  let t0;
  if ($[0] !== control) {
    t0 = {
      control,
      name: "listingType"
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const listingType = useWatch(t0);
  const isDemand = listingType === ListingType.DEMAND;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [...ROOM_FLAG_KEYS];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== control) {
    t2 = {
      control,
      name: t1
    };
    $[3] = control;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const flagValues = useWatch(t2);
  let t3;
  if ($[5] !== flagValues) {
    t3 = ROOM_FLAG_KEYS.filter((_, i) => flagValues?.[i]);
    $[5] = flagValues;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const selectedFlags = t3;
  let t4;
  if ($[7] !== control) {
    t4 = {
      control,
      name: "associatedUnitId"
    };
    $[7] = control;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isAssociated = !!useWatch(t4);
  let t5;
  if ($[9] !== setValue) {
    t5 = next => {
      for (const key of ROOM_FLAG_KEYS) {
        setValue(key, next.includes(key), {
          shouldDirty: true
        });
      }
    };
    $[9] = setValue;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleFlagsChange = t5;
  let t6;
  if ($[11] !== control || $[12] !== handleFlagsChange || $[13] !== isAssociated || $[14] !== isDemand || $[15] !== isMobile || $[16] !== selectedFlags || $[17] !== t) {
    t6 = {
      control,
      isMobile,
      t,
      isDemand,
      isAssociated,
      selectedFlags,
      handleFlagsChange
    };
    $[11] = control;
    $[12] = handleFlagsChange;
    $[13] = isAssociated;
    $[14] = isDemand;
    $[15] = isMobile;
    $[16] = selectedFlags;
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}